export default __webpack_public_path__ + "static/media/icon-dedicated-server-round.c3c30641.svg";